<div class="container-fluid p-3 bg-amber-50">
  <div class="bg-white rounded-md  border-2 border-blue-900 border-gray-300 px-4 py-2 sm:p-6 mb-4">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
    <div class="flex gap-3">
    
      <div class="flex-1">
        <h4 class="text-xl sm:text-2xl font-bold text-slate-800 mb-1">
          {{stepDetails?.name}}
        </h4>
    
        <h5 class="text-base sm:text-lg text-blue-600 font-semibold mb-3">
          [{{ PraposalName }}]
        </h5>
    
    
      </div>
      <div>
        
        <span class="inline-flex items-center px-3 py-1.5 border-2 rounded-full text-sm font-bold transition-all" [ngClass]="{
                        'bg-slate-100 text-slate-700 border border-slate-500': stepDetails?.step_status == 0,
                        'bg-emerald-100 text-emerald-700 border border-emerald-500': stepDetails?.step_status == 'approved',
                        'bg-amber-100 text-amber-700 border border-amber-500': stepDetails?.step_status == 'recommended',
                        'bg-blue-100 text-blue-700 border border-blue-500': stepDetails?.step_status == 'initiated'
                      }">
          <span class="w-2 h-2 rounded-full mr-2 animate-pulse" [ngClass]="{
                          'bg-slate-500': stepDetails?.step_status == 0,
                          'bg-emerald-500': stepDetails?.step_status == 'approved',
                          'bg-amber-500': stepDetails?.step_status == 'recommended',
                          'bg-blue-500': stepDetails?.step_status == 'initiated'
                        }"></span>
          {{ stepDetails?.step_status == 0 ? " PENDING" : (stepDetails?.step_status | uppercase) }}
        </span>
      </div>
    </div>

      <!-- Action Buttons -->
      <div class="flex flex-wrap items-center gap-2">
        <!-- <button (click)="getPdf()" 
                class="inline-flex items-center px-4 py-2.5 bg-white border-2 border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 hover:border-slate-400 transition-all duration-200 font-medium text-sm shadow-sm hover:shadow">
          <i class="pi pi-file-pdf mr-2"></i> PDF
        </button> -->

       

        <ng-container *ngIf="stepDetails?.can_edit">
          <button (click)="routeConfig.emit({isRouteConfig: true})"  class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i> Save/Forward/Route Config
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />


    <!-- IDEX Vendor List -->
    <div *ngIf="stepDetails.code == 'idex_005' ">
      <form [formGroup]="hpscFormEveluation" class=" w-100 align-middle border-2 border-blue-900 border-gray-300 px-4 py-2 sm:p-6 mb-4">
  
        <!-- Row 1 -->
        <div class="row g-0">
          <div class="col-3 p-2 text-blue-600 fw-semibold ">Challenge Titles <span class="text-orange-500">*</span> </div>
          <div class="col-3 p-2 ">
            <input
            pInputText
              type="text" readonly
              class="form-control form-control-sm"
              formControlName="title"
              autocomplete="off"
              placeholder="Start entering challenge title"
              style="text-align: start"
            />
          </div>
      
          <div class="col-3 p-2 text-blue-600 fw-semibold ">Name of the Evaluator <span class="text-orange-500">*</span> </div>
          <div class="col-3 p-2 ">
            <input
              type="text"
              pInputText
              class="form-control form-control-sm"
              formControlName="name_evaluator"
              autocomplete="off"
              placeholder="Start entering evaluator name"
              style="text-align: start"
            />
          </div>
        </div>
      
        <!-- Row 2 -->
        <div class="row g-0">
          <div class="col-3 p-2 text-blue-600 fw-semibold ">
            Category <span class="text-orange-700">*</span> <br /><small class="text-orange-700">  (DISC / OC / ADITI etc.)</small>
          </div>
          <div class="col-3 p-2 ">
            <input
              type="text"
              pInputText
              readonly
              class="form-control form-control-sm"
              formControlName="category"
              autocomplete="off"
              placeholder="Start entering category"
              style="text-align: start"
            />
          </div>
      
          <div class="col-3 p-2 text-blue-600 fw-semibold ">Organisation of the Evaluator <span class="text-orange-500">*</span> </div>
          <div class="col-3 p-2 ">
            <input
              type="text"
              pInputText
              
              class="form-control form-control-sm"
              formControlName="org_evaluator"
              autocomplete="off"
              placeholder="Start entering evaluator organisation"
              style="text-align: start"
            />
          </div>
        </div>
      
        <!-- Row 3 -->
        <div class="row g-0">
          <div class="col-3 p-2 text-blue-600 fw-semibold ">Nodal Agency <span class="text-orange-500"></span> </div>
          <div class="col-3 p-2 ">
            <input
              type="text"
              pInputText
              readonly
              class="form-control form-control-sm"
              formControlName="nodal_agecy"
              autocomplete="off"
              placeholder="Start entering nodal agency"
              style="text-align: start"
            />
          </div>
      
          <div class="col-3 p-2 text-blue-600 fw-semibold ">Contact details <span class="text-orange-500">*</span> </div>
          <div class="col-3 p-2 ">
            <input pInputText type="text"  formControlName="contact_detail" class="form-control form-control-sm" placeholder="Start entering contact details"
              placeholder="Enter 10-digit number"
              style="text-align: start"
            />
            <div *ngIf="hpscFormEveluation.get('contact_detail')?.touched &&
                        hpscFormEveluation.get('contact_detail')?.invalid"
                  class="text-danger small">
              Please enter a valid contact number (e.g. 9876543210 or +91 9876543210).
            </div>
          </div>
        </div>
      
        <!-- Row 4 -->
        <div class="row g-0">
          <div class="col-3 p-2 text-blue-600 fw-semibold ">Date of evaluation <span class="text-orange-500">*</span> </div>
          <div class="col-3 p-2 ">
            <input
              type="date"
              pInputText
              
              class="form-control form-control-sm"
              formControlName="date_evaluator"
              autocomplete="off"
              placeholder="Start entering evaluation date"
              style="text-align: start"
            />
          </div>
      
          <div class="col-3 p-2 text-blue-600 fw-semibold ">Email ID <span class="text-orange-500">*</span> </div>
          <div class="col-3 p-2 ">
            <input
              type="email"
              class="form-control form-control-sm"
              formControlName="email_id"
              autocomplete="off"
              placeholder="Start entering email ID"
              style="text-align: start"
            />
          </div>
        </div>
      
      </form>
    </div>

    <!-- <div class="flex gap-2 my-3">
      <button
        type="button"
        class="bg-green-100 text-green-700 border-2 border-green-300 hover:bg-green-500 hover:text-white px-4 py-2 rounded shadow transition"
        (click)="changeStatus('Qualify')"
      >
        Qualify
      </button>
      <button
        type="button"
        class="bg-red-100 text-red-700 border-2 border-red-300 hover:bg-red-500 hover:text-white px-4 py-2 rounded shadow transition"
        (click)="changeStatus('Disqualify')"
      >
        Disqualify
      </button>
    </div> -->
    <p-table #dt [value]="vendorList" [paginator]="vendorList.length > 10" [rows]="10" [showCurrentPageReport]="true"
      selectionMode="multiple" [scrollable]="true" [(selection)]="selectedProposals" [resizableColumns]="true"
      [reorderableColumns]="true" dataKey="id" class="min-w-full text-sm">
      <ng-template pTemplate="header">
        <tr>
          <!-- <th class="w-10 bg-blue-100 border-b border-blue-200"></th> -->
          <ng-container *ngFor="let column of tableColumns">
            <th [pSortableColumn]="column.field" pResizableColumn
              class="px-4 py-2 bg-blue-100 text-blue-900 font-semibold border-b border-blue-200 whitespace-nowrap">
              <span>{{ column.header }}</span>
              <i class="pi pi-sort-alpha-down ml-2 text-blue-400 text-base"></i>
              <p-columnFilter class="text-gray-600" [type]="'text'" [field]="column.field" display="menu"
                [showMatchModes]="true" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
            </th>
          </ng-container>
          <th *ngIf="stepDetails.can_edit" pFrozenColumn alignFrozen="right"
            class="px-4 py-2 bg-blue-100 text-blue-900 font-semibold border-b border-blue-200 whitespace-nowrap">
            Actions
          </th>
          <!-- <th pFrozenColumn class="px-4 py-2 bg-blue-100 text-blue-900 font-semibold border-b border-blue-200 whitespace-nowrap">Actions</th> -->
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-proposal>
        <tr class="hover:bg-blue-50 transition-colors duration-200">
          <!-- <td  class="align-middle px-2 py-2 border-b border-gray-100">
            <p-tableCheckbox [disabled]="proposal.status === 'Recommended' || proposal.status === 'Rejected'"
              [value]="proposal"></p-tableCheckbox></td> -->
          <ng-container *ngFor="let column of tableColumns">
            <td *ngIf="!proposal.isEditable" class="align-middle px-4 py-2 border-b border-gray-100 whitespace-nowrap">
              <ng-container [ngSwitch]="column.type">
                <ng-container *ngSwitchCase="'status'">
  <span
    class="badge px-2 py-1 rounded-md border-2"
    [ngClass]="{
      'bg-green-100 text-green-700 border-green-300': proposal.vendor_status === 'Qualify',
      'bg-red-100 text-red-700 border-red-300': proposal.vendor_status === 'Disqualify',
      'bg-yellow-100 text-yellow-700 border-yellow-300': !proposal.vendor_status || (proposal.vendor_status !== 'Qualify' && proposal.vendor_status !== 'Disqualify')
    }"
  >
    {{ getHPSCStatus(proposal.vendor_status) }}
  </span>
</ng-container>
                <ng-container *ngSwitchDefault>
                    <span class="whitespace-pre-wrap min-w-[200px]">{{ getNestedData(proposal, column.field) || '-' }}</span>
                </ng-container>
              </ng-container>
            </td>
            <td *ngIf="proposal.isEditable" class="align-middle px-4 py-2 border-b border-gray-100 whitespace-nowrap">
              <ng-container [ngSwitch]="column.isEditable">
                <ng-container *ngSwitchCase="false">
                  <span class="whitespace-pre-wrap min-w-[200px]">{{ getNestedData(proposal, column.field) || '-' }}</span>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <textarea *ngIf="column.type === 'textarea'"
                    class="border-2 border-gray-300 rounded-md p-2  min-w-[200px]"
                    rows="2"
                    [(ngModel)]="proposal[column.field]"
                    [value]="proposal[column.field]"
                    (keypress.enter)="autoLineUpdate($event)">
                  </textarea>
                  <input *ngIf="column.type === 'number'"
                    class="border-2 border-gray-300 rounded-md p-2  min-w-[200px]"
                    type="number"
                    [(ngModel)]="proposal[column.field]"
                   
                    
                   >
                </ng-container>
              </ng-container>
            </td>
          </ng-container>
          <td *ngIf="stepDetails.can_edit" pFrozenColumn alignFrozen="right"
            class="align-middle px-4 py-2 border-b border-gray-100 whitespace-nowrap">
            <button
              class="border-2 border-blue-400 bg-blue-100 text-blue-700 font-bold px-2 py-1 rounded shadow-none mr-2 text-base hover:border-blue-500 hover:bg-blue-200 transition-colors outline-none focus:outline-none"
              *ngIf="!proposal.isEditable"
              (click)="proposal.isEditable = true"
              title="Edit">
              <i class="pi pi-pencil"></i> Edit
            </button>
            <button
              class="border-2 border-green-400 bg-green-100 text-green-700 font-bold px-2 py-1 rounded shadow-none mr-2 text-base hover:border-green-500 hover:bg-green-200 transition-colors outline-none focus:outline-none"
              *ngIf="proposal.isEditable"
              (click)="proposal.isEditable = false; onRowSave(proposal)"
              title="Save">
              <i class="pi pi-save"></i> Save
            </button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="tableColumns.length + 2" class="text-center py-8 text-gray-400"><i
              class="pi pi-info-circle mr-2"></i> No proposals found.</td>
        </tr>
      </ng-template>
    </p-table>

    <div class=" my-3">
      <app-upload-document [isEditable]="stepDetails?.can_edit"></app-upload-document>
    </div>

</div>


